import { render, staticRenderFns } from "./PaginationForAudit.vue?vue&type=template&id=4f380bee"
import script from "./PaginationForAudit.vue?vue&type=script&lang=js"
export * from "./PaginationForAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports